// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"295":"batchquery","535":"login","945":"mainlayout"}[chunkId] + "." + {"295":"845e0c90","535":"76d6177c","945":"90c3d0fc"}[chunkId] + ".css";
};